import { render, staticRenderFns } from "./FancyCard.vue?vue&type=template&id=9c46b742&"
import script from "./FancyCard.vue?vue&type=script&lang=js&"
export * from "./FancyCard.vue?vue&type=script&lang=js&"
import style0 from "./FancyCard.vue?vue&type=style&index=0&id=9c46b742&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardText,VDivider,VSkeletonLoader})
